import React, { ReactNode, createContext, useContext, useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

interface CustomFundLineupContextValue {
  returnTo: string;
  planName: string;
}

const CustomFundLineupContext = createContext<CustomFundLineupContextValue>({
  returnTo: '',
  planName: '',
});

interface CustomFundLineupProviderProps {
  children: ReactNode;
}

export const CustomFundLineupProvider: React.FC<CustomFundLineupProviderProps> = ({ children }) => {
  const [searchParams] = useSearchParams();

  const [returnTo] = useState<string>(() => searchParams.get('return_to') || '');
  const [planName] = useState<string>(() => searchParams.get('plan_name') || '');

  const value: CustomFundLineupContextValue = useMemo(
    () => ({
      returnTo,
      planName,
    }),
    [returnTo, planName]
  );

  return <CustomFundLineupContext.Provider value={value}>{children}</CustomFundLineupContext.Provider>;
};

export const useCustomFundLineup = (): CustomFundLineupContextValue => {
  return useContext(CustomFundLineupContext);
};
